// @ts-nocheck

import { useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material'
import { deleteExceptionRule } from 'utils/ExceptionRule'
import { useTranslation } from 'react-i18next'

const DeleteExceptionRule = ({ open, setOpenDelete, setAlert, setOpenAlert, selectedRow, reloading, rows, setSelectedRow }) => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const data = rows.filter((row) => selectedRow.includes(row.id)).map((row) => ({ id: row.id, name: row.name }))

    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpenDelete(false)}
            >
                <DialogTitle>
                    <Typography variant='body3'>{t('settings.exception_rules.table.dialog.delete.title')}</Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography variant='body1'>
                        {t('settings.exception_rules.table.dialog.delete.message')}
                    </Typography>
                    <ul>
                        {data.map((exception_rules, index) =>
                            <li key={index}>
                                {exception_rules.exception_rulesname}
                            </li>
                        )}
                    </ul>
                </DialogContent>

                <DialogActions sx={{ pb: 2, pr: 3 }}>
                    <Button
                        variant='contained'
                        disableElevation
                        onClick={() => {
                            deleteExceptionRule(setLoading, selectedRow)
                                .then(() => {
                                    setOpenDelete(false)
                                    setAlert({ msg: t('settings.exception_rules.table.dialog.delete.messages.success'), severity: 'success' })
                                    setOpenAlert(true)
                                    reloading()
                                    setSelectedRow([])
                                })
                                .catch((error) => {
                                    console.error(error)
                                    setLoading(false)
                                })

                        }}
                        color='error'
                        loading={loading}
                    >
                        {t('settings.exception_rules.table.dialog.delete.buttons.delete')}
                    </Button>
                    <Button
                        variant='outlined'
                        onClick={() => setOpenDelete(false)}
                    >
                        {t('settings.exception_rules.table.dialog.delete.buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export { DeleteExceptionRule }
